import { Texto } from '@gravitate-js/excalibrr'
import { Switch } from 'antd'

type ProjectedDropToggleProps = {
  value: boolean
  onChange: (value: boolean) => void
  isMobile?: boolean
}

export function ProjectedDropToggle({ value, onChange, isMobile }: ProjectedDropToggleProps) {
  return (
    <div className='flex items-center px-1'>
      <Texto appearance='medium' weight='bold' className='text-ellipsis pr-2'>
        Include Assigned Loads
      </Texto>
      <Switch defaultChecked={value} onChange={onChange} size={isMobile ? 'small' : 'default'} />
    </div>
  )
}
